import React, { useState } from "react";
import styles from "./Header.module.css";
import { NavLink } from "../../types";

interface HeaderProps {
  companyName: string;
}

const Header: React.FC<HeaderProps> = ({ companyName }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks: NavLink[] = [
    { id: 1, label: "HOME", href: "#home" },
    { id: 2, label: "ABOUT", href: "#about" },
    { id: 3, label: "SERVICES", href: "#services" },
    { id: 4, label: "PROJECTS", href: "#projects" },
    { id: 5, label: "CONTACT US", href: "#contact", isCTA: true },
    // { id: 5, label: "GET QUOTE", href: "#contact", isCTA: true },
  ];

  const handleNavClick = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className="container">
        <nav className={styles.nav}>
          <div className={styles.logo}>
            {companyName.split("").map((letter, index) => (
              <span
                key={index}
                className={letter === "|" ? styles.logoAccent : ""}
              >
                {letter}
              </span>
            ))}
          </div>

          <div
            className={`${styles.navLinks} ${
              isMenuOpen ? styles.navLinksActive : ""
            }`}
          >
            {navLinks.map((link) =>
              link.isCTA ? (
                <a
                  key={link.id}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(link.href);
                  }}
                  className={styles.ctaButton}
                >
                  {link.label}
                </a>
              ) : (
                <a
                  key={link.id}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(link.href);
                  }}
                  className={styles.navLink}
                >
                  {link.label}
                </a>
              ),
            )}
          </div>

          <button
            className={styles.mobileMenu}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`fas fa-${isMenuOpen ? "times" : "bars"}`} />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
